'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const WizardSidebarTimelineCurrentIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="WizardSidebarTimelineCurrentIcon">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8" fill="white" stroke="#5073C3" strokeWidth="2" />
        <circle cx="9" cy="9" r="3.5" fill="white" stroke="#5073C3" strokeWidth="2" />
      </svg>
    </SvgIcon>
  )
}

WizardSidebarTimelineCurrentIcon.propTypes = {
  sx: PropTypes.object
}
